import { createAsyncThunk } from '@reduxjs/toolkit'

import { fetchPublishedListings, fetchPublishedListingsTotal } from '@app/api'

import { getUserLanguage } from '@app/utils'

import { DEFAULT_LISTINGS_SORTING, ListingsSorting } from '@lib/components'

export const getPublishedListingsThunk = createAsyncThunk(
  'publishedListings/fetch',
  async ({
    skip = 0,
    count,
    search,
    transactionType,
    sort = DEFAULT_LISTINGS_SORTING,
  }: {
    skip?: number
    count?: number
    search?: string
    transactionType?: string
    sort?: ListingsSorting
  } = {}) => {
    const userLanguage = getUserLanguage()

    const { listings, total } = await fetchPublishedListings(
      userLanguage,
      'Puzzle',
      count,
      skip,
      search,
      transactionType,
      sort
    )

    return {
      listings,
      total,
      skip,
      count,
      search,
      transactionType,
      sort,
    }
  }
)

export const getPublishedListingsTotalThunk = createAsyncThunk(
  'publishedListings/fetchTotal',
  async () => {
    const total = await fetchPublishedListingsTotal()

    return total
  }
)
